<template>
  <CancerView icd="C90.0sample" icd-presentation-string="C90.0"
              icd-description="Multiple myeloma (sample)"
              disease-description="multiple myeloma"
              :mesh-ids="['D009101']"
              mesh-description="Multiple Myeloma"
              :dashboard6-included="false">
  </CancerView>
</template>

<script>
import CancerView from '@/components/CancerView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'multiple-myeloma-sample-page',
  components: {
    CancerView
  }
});
</script>
